import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";

export const generateAndSendPDF = async (formData, sectionName) => {
  const doc = new jsPDF();
  const replyToEmail = localStorage.getItem("userEmail") || null;
  const replyToName = localStorage.getItem("username") || null;

  const tableRows = [];
  const fieldNames = {
    apellidos: "Apellidos",
    nombre: "Nombre",
    departamento: "Departamento",
    fechaAlta: "Fecha de Alta",
    fechaBaja: "Fecha de Baja",
    email: "Correo Electrónico",
    telefono: "Teléfono",
    ordenador: "Ordenador",
    pantallas: "Pantallas",
    numPantallas: "Número de Pantallas",
    movil: "Móvil",
    otroHardware: "Otro Hardware",
    accesoServidor: "Acceso al Servidor",
    office: "Office",
    abbantia: "Abbantia",
    accesoRemoto: "Acceso Remoto",
    appInterna: "App Interna",
    observaciones: "Observaciones",
    usuarioAbbantia: "Usuario Abbantia",
    pinPortero: "Pin Portero",
    firmadoPor: "Firmado por",
    fechaFirma: "Fecha Firma",
    tieneFechaBaja: "Tiene Fecha de Baja",
  };

  const userName = formData.nombre
    ? `${formData.nombre} ${formData.apellidos}`.trim().toUpperCase()
    : "SIN_NOMBRE";

  doc.setFontSize(18);
  doc.text(sectionName, 14, 20);
  doc.setFontSize(12);
  doc.text("Datos ingresados:", 14, 30);

  Object.entries(formData).forEach(([key, value]) => {
    let formattedValue = value;

    if (key === "fechaBaja" && (!value || value === "null" || value === "")) {
      formattedValue = "No especificada";
    } else if (key.includes("fecha") && value) {
      formattedValue = dayjs(value).format("YYYY-MM-DD"); // Mantener el formato esperado
    }

    const booleanValue =
      formattedValue === true
        ? "Sí"
        : formattedValue === false
        ? "No"
        : formattedValue || "-";

    tableRows.push([fieldNames[key] || key, booleanValue]);
  });

  autoTable(doc, {
    startY: 35,
    head: [[userName, ""]],
    body: tableRows,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [0, 102, 204] },
    alternateRowStyles: { fillColor: [240, 240, 240] },
  });

  // Convertir el PDF a base64 para enviarlo en JSON
  const pdfBase64 = doc.output("datauristring");

  // Adjuntar el PDF en base64 al objeto formData antes de enviarlo
  const dataToSend = {
    ...formData,
    pdf: pdfBase64,
    replyToEmail,
    replyToName,
  };

  try {
    const response = await fetch("mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataToSend), // Enviar todos los datos como JSON
    });

    const result = await response.json();
    return result.success ? result.message : "Error al enviar el PDF por correo";
  } catch (error) {
    return "Error al conectar con el servidor de correo.";
  }
};
